import FIELD_TYPES from '../../../configs/fieldTypes';

export const isSelfLinkField = (field, catalogId) =>
  field.get('type') === FIELD_TYPES.OBJECT &&
  (field
    .getIn(['config', 'catalogs'])
    ?.some((catalog) => ['*', String(catalogId)].includes(String(catalog.get('id')))) ||
    field.getIn(['config', 'views'])?.some((view) => String(view.get('catalogId')) === String(catalogId)));

export function recordsToLinks(records, tasks, catalogId, fieldId, direction) {
  if (!records || !fieldId) return [];
  const visible = new Map(tasks.map((task) => [String(task.id), task.id]));
  const links = new Map();

  records.forEach((record) => {
    const owner = visible.get(String(record.get('id')));
    if (owner == null) return;
    record.getIn(['values', fieldId])?.forEach((item) => {
      if (String(item.get('catalogId')) !== String(catalogId) || item.get('isRemoved')) return;
      const related = visible.get(String(item.get('recordId')));
      if (related == null || related === owner) return;
      const [source, target] = direction === 'successors' ? [owner, related] : [related, owner];
      const id = JSON.stringify([source, target]);
      links.set(id, { id, source, target, type: 'e2s' });
    });
  });
  return [...links.values()];
}
